import { TraitRegistryCategory } from '../../../registry/trait/TraitRegistryCategory';
import { TraitTypeCheckbox } from '../../../registry/trait/traitTypes/TraitTypeCheckbox';
import { TraitTypeNumericWithSlider } from '../../../registry/trait/traitTypes/TraitTypeNumericWithSlider';
export class TraitsWordTask extends TraitRegistryCategory {
    label = 'WordInput';
    constructor(parent) {
        super(parent);
        super.init();
    }
    isCaseSensitive = () => new TraitTypeCheckbox({
        parent: this,
        init: true,
        default: false,
    });
    accuracy = () => new TraitTypeNumericWithSlider({
        parent: this,
        min: 0,
        max: 100,
        default: 100,
    });
    isManualSend = () => new TraitTypeCheckbox({
        parent: this,
        init: true,
        default: false,
    });
    shouldShowAlternatives = () => new TraitTypeCheckbox({
        parent: this,
        init: true,
        default: false,
    });
    isRegex = () => new TraitTypeCheckbox({
        parent: this,
        init: true,
        default: false,
    });
}
